"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rovigo": {
    "4e7979a3": [{
      "hkey": "c7bbfaa9",
      "slug": "boara-polesine-granzette",
      "name": "Boara Polesine-Granzette",
      "primary": true,
      "skipSearch": false
    }],
    "boara-polesine": [{
      "hkey": "c7bbfaa9",
      "slug": "boara-polesine-granzette",
      "name": "Boara Polesine-Granzette",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9ad52071": [{
      "hkey": "1ea890c9",
      "slug": "borsea-santa-rita",
      "name": "Borsea-Santa Rita",
      "primary": true,
      "skipSearch": false
    }],
    "borsea": [{
      "hkey": "1ea890c9",
      "slug": "borsea-santa-rita",
      "name": "Borsea-Santa Rita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "830519cd": [{
      "hkey": "5f3e6ab3",
      "slug": "centro-storico",
      "name": "Centro storico",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "5f3e6ab3",
      "slug": "centro-storico",
      "name": "Centro storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8078ff00": [{
      "hkey": "0e98ce2d",
      "slug": "commenda",
      "name": "Commenda",
      "primary": true,
      "skipSearch": false
    }],
    "commenda-est": [{
      "hkey": "0e98ce2d",
      "slug": "commenda",
      "name": "Commenda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4f06926f": [{
      "hkey": "0e98ce2d",
      "slug": "commenda",
      "name": "Commenda",
      "primary": true,
      "skipSearch": false
    }],
    "commenda-ovest": [{
      "hkey": "0e98ce2d",
      "slug": "commenda",
      "name": "Commenda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "rovigo"
    }],
    "f34b804f": [{
      "hkey": "c7bbfaa9",
      "slug": "boara-polesine-granzette",
      "name": "Boara Polesine-Granzette",
      "primary": true,
      "skipSearch": false
    }],
    "granzette": [{
      "hkey": "c7bbfaa9",
      "slug": "boara-polesine-granzette",
      "name": "Boara Polesine-Granzette",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "rovigo"
    }]
  }
};
exports["default"] = _default;